"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _visualInterest = require("@decisiv/design-tokens/lib/color/visual-interest");

var _IconWrapper = _interopRequireDefault(require("../IconWrapper"));

var _StyledLabel = _interopRequireDefault(require("../StyledLabel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FilterSimplePrimary = function FilterSimplePrimary(_ref) {
  var ariaLabel = _ref['aria-label'],
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      text = _ref.text,
      Icon = _ref.badgeIcon,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? 'information' : _ref$badgeColor,
      count = _ref.count;
  var buttonText = count ? "".concat(count, " ").concat(text) : text;
  var colorForBadge = disabled ? _visualInterest.VisualInterestColorName.licoriceMousse : badgeColor;
  return _react.default.createElement(_react.default.Fragment, null, Icon && _react.default.createElement(_IconWrapper.default, {
    badgeColor: colorForBadge
  }, _react.default.createElement(Icon, {
    size: "small",
    role: "img",
    "aria-label": ariaLabel
  })), _react.default.createElement(_StyledLabel.default, {
    active: active,
    kind: "primary",
    hasBadge: !!Icon,
    marginLeft: 1
  }, buttonText));
};

var _default = FilterSimplePrimary;
exports.default = _default;